import UiButton from './UiButton.vue'
import UiCheckbox from './UiCheckbox.vue'
import UiIcon from './UiIcon.vue'
import UiInput from './UiInput.vue'
import UiRange from './UiRange.vue'
import UiSwitch from './UiSwitch.vue'

export default [UiButton, UiSwitch, UiRange, UiIcon, UiCheckbox, UiInput]
